import { useState, useCallback } from 'react';
import { IBookmark, IBookmarkTag } from '@/common/types/IBookmark';
import { ApiService } from '@/common/services/ApiService';

export function useTagsAndCategories() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [tags, setTags] = useState<IBookmarkTag[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  const fetchTagsAndCategories = useCallback(async (url: string, existingData?: Partial<IBookmark>) => {
    try {
      setLoading(true);
      setError(null);

      const response = await ApiService.getTags(url, existingData);

      setTags(response.tags.map(tag => ({ name: tag })));
      setCategories(response.categories);

      return {
        tags: response.tags.map(tag => ({ name: tag })),
        categories: response.categories,
      };
    } catch (err) {
      setError('Failed to fetch tags and categories');
      console.error('Error fetching tags and categories:', err);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    tags,
    categories,
    fetchTagsAndCategories,
  };
}
